import { render, staticRenderFns } from "./ColorSolutionsMoreOptionsModal.vue?vue&type=template&id=ad67a760&scoped=true&lang=pug&"
import script from "./ColorSolutionsMoreOptionsModal.vue?vue&type=script&lang=js&"
export * from "./ColorSolutionsMoreOptionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad67a760",
  null
  
)

export default component.exports